/*
 * ngFor="let item of mbbAllowedOfferings | sortBy: 'subscriptionOffering.dataVolume'; trackBy: trackByFn"
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortBy',
  standalone: true,
})
export class SortByPipe implements PipeTransform {
  transform(array: any, field: string): any[] {
    const prop = field.split('.');
    const len = prop.length;

    if (!Array.isArray(array)) {
      return;
    }

    // https://stackoverflow.com/questions/53420055/error-while-sorting-array-of-objects-cannot-assign-to-read-only-property-2-of/53420326
    array = array.slice();

    // sort nested properties
    // https://stackoverflow.com/questions/5073799/how-to-sort-a-javascript-array-of-objects-by-nested-object-property
    array.sort((a, b) => {
      let i = 0;
      while (i < len) {
        a = a[prop[i]] || 0;
        b = b[prop[i]] || 0;
        i++;
      }

      if (a < b) {
        return -1;
      } else if (a > b) {
        return 1;
      } else {
        return 0;
      }
    });

    return array;
  }
}
